export const app_version = "v 1.0.0.10";
export const durations = [
    { "value": "2025", "label": "FY 2025-2026" },
    { "value": "2024", "label": "FY 2024-2025" },
    { "value": "0"   , "label": "Today" },
    { "value": "1"   , "label": "Yesterday" },
    { "value": "2"   , "label": "This Week" },
    { "value": "3"   , "label": "Last Week" },
    { "value": "4"   , "label": "This Month" },
    { "value": "5"   , "label": "Last Month" },
    { "value": "6"   , "label": "Last 2 Month" },
    { "value": "7"   , "label": "Last 3 Month" },
    { "value": "8"   , "label": "Last Year" },
    { "value": "9"   , "label": "Last 1 Year" }
]

export const clearCache = () => {
    caches.keys().then(function(names) {
        for (let name of names)
            caches.delete(name);
    });
    setTimeout(() => window.location.reload(), 5000);
}

export const ACCOUNTS_PHONENUMBER = "+91 6362789267";
export const DISPATCH_PHONENUMBER = "+91 7899561486";
export const ORDERS_PHONENUMBER = "+91 9844437332";
export const ENQUIRY1_PHONENUMBER = "+91 9611724989";
export const ENQUIRY2_PHONENUMBER = "+91 9590356562";